import { render, staticRenderFns } from "./ListCoverClaimed.vue?vue&type=template&id=a529c120"
import script from "./ListCoverClaimed.vue?vue&type=script&lang=js"
export * from "./ListCoverClaimed.vue?vue&type=script&lang=js"
import style0 from "./ListCoverClaimed.vue?vue&type=style&index=0&id=a529c120&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports